<template>
  <div class="skeleton-row"><div></div></div>
</template>

<script>
export default {
  name: "skeleton-row"
}
</script>

<style>
.skeleton-row {
  background-color: rgba(255, 255, 255, 0.05);
  transform: translate3d(0px, 0px, 0px);
  position: relative;
  border-radius: 0.25rem;
  height: 4.5rem;
  overflow: hidden;
}

.skeleton-row:nth-child(2) {
  opacity: 0.6;
}

.skeleton-row:nth-child(3) {
  opacity: 0.4;
}

@keyframes bg-move {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.skeleton-row > div {
  transform: translate3d(0px, 0px, 0px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-image: linear-gradient(
    to right,
    rgba(134, 134, 134, 0.527) 0%,
    rgba(146, 146, 146, 0.603) 30%,
    rgba(151, 151, 151, 0.308) 40%,
    rgba(124, 124, 124, 0.548) 80%
  );
  animation: bg-move 1.5s -0.75s ease infinite;
}
</style>